import { apiGet, apiPost, apiPut, apiPatch, apiDelete } from '@/app/api/core/http';
import { PRODUCTS_PATHS } from './paths';

export const productOrdersApiAdapter = {
  postProductOrder: (id, data) => apiPost(`${PRODUCTS_PATHS.products}/${id}/order`, { data }),
  getProductAnalysisOrders: (params) => apiGet(PRODUCTS_PATHS.analysisOrders + PRODUCTS_PATHS.suffix, { params }),
  getAnalysisTypes: () => apiGet(PRODUCTS_PATHS.analysisTypes),
  createAnalysis: (data) => apiPost(PRODUCTS_PATHS.analysisOrders, { data }),
  orderStatuses: {
    analysis: (params) =>
      apiGet(PRODUCTS_PATHS.orderStatuses, {
        params: { ...params, useInAnalysisOrder: true },
      }),
    product: (params) =>
      apiGet(PRODUCTS_PATHS.orderStatuses, {
        params: { ...params, useInProductOrder: true },
      }),
  },
  updateProductOrderInfo: (id, status, staffComment) =>
    apiPatch(`${PRODUCTS_PATHS.orders}/${id}`, { data: { status, staffComment } }),
  updateProductOrder: (id, status_id) => apiPut(`${PRODUCTS_PATHS.products}/order/${id}/status/${status_id}`),
  updateProductAnalysisOrder: (id, status_id) =>
    apiPut(`${PRODUCTS_PATHS.products}/analysis-order/${id}/status/${status_id}`),
  deleteProductOrder: (id) => apiDelete(`${PRODUCTS_PATHS.orders}/${id}`),
  deleteProductAnalysis: (id) => apiDelete(`${PRODUCTS_PATHS.analysisOrders}/${id}`),
};
